module.exports = __webpack_public_path__ + "resources/img/img_LOH_m_kr.a2da8e2b556b1593b15edc570de8656d.png";